<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <div class="con-main">
          <div class="tgrk">
            <div class="tgrk-list">
              <div class="tgrk-list-title">《大学》投稿系统网址</div>
              <div class="tgrk-list-con"><a href="http://www.daxuemag.cn" target="_blank">http://www.daxuemag.cn</a></div>
            </div>
            <div class="tgrk-list">
              <div class="tgrk-list-title">《课堂内外》教研版投稿邮箱</div>
              <div class="tgrk-list-con">ktnwjyb@foxmail.com</div>
            </div>
            <div class="tgrk-list">
              <div class="tgrk-list-title">《电脑迷》投稿邮箱</div>
              <div class="tgrk-list-con">Dnmkexuejiaoyu@sina.com</div>
            </div>
            <div class="tgrk-list">
              <div class="tgrk-list-title">《健康人报·健康科普》投稿邮箱</div>
              <div class="tgrk-list-con">jkrkepu@sina.com</div>
            </div>
            <div class="tgrk-list">
              <div class="tgrk-list-title">《科研成果与传播》投稿邮箱</div>
              <div class="tgrk-list-con">kycgycb@sina.com</div>
            </div>
          </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<style scoped>
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
.tgrk{
  padding-top: 30px;
}
.tgrk-list{
  text-align: center;
  padding: 20px 0;
  font-size: 18px;
}
.tgrk-list-title{
  font-weight: bold;
  padding: 0 0 10px 0;
}
</style>

<script setup>

</script>
